import { render } from "./MailPreviewContent.vue?vue&type=template&id=3cf99dbc&scoped=true&ts=true"
import script from "./MailPreviewContent.vue?vue&type=script&lang=ts"
export * from "./MailPreviewContent.vue?vue&type=script&lang=ts"

import "./MailPreviewContent.vue?vue&type=style&index=0&id=3cf99dbc&scoped=true&lang=css"

import exportComponent from "/Users/paulbele/Code/repositories/maatoo-app-master/package/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf99dbc"]])

export default __exports__